export function getLocalizedData(cmsData: string, language: string) {
    if (cmsData.includes('_')) {
      const [zh, en] = cmsData.split('_');
      return language === 'zh' ? zh : en;
    }
    return cmsData;
}